import { useProducts as sharedUseProducts } from '@shared/products-core';

export const useProducts: typeof sharedUseProducts = (...args) => sharedUseProducts(...args);
